import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocalizationPipe } from '@shared/modules/localization';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

interface SidebarMenuItem {
  title: string;
  icon?: string;
  route?: string;
  disabled?: boolean;
  open?: boolean;
  children?: SidebarMenuItem[];
}

@Component({
  selector: 'ui-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgTemplateOutlet,
    RouterLink,
    NzMenuModule,
    NzIconModule,
    NzTypographyModule,
    LocalizationPipe,
  ],
})
export class UISidebarMenu {
  @Input() menus: SidebarMenuItem[] = [];
}
